import { useCallback, useMemo } from "react";

import { useSelector } from "react-redux";

import { useAppDispatch } from "../utils";

import {
  selectPaginatedPaymentActivity,
  selectPaymentActivity,
  selectFormattedPaginatedPaymentActivity,
  createSelectFormattedPaymentActivityByKey,
  selectTotal,
  selectPageMap,
  selectSelectedPaymentActivity,
  selectFilters,
  selectById,
} from "./selectors";
import { actions } from "./slice";

import type { RootState } from "../store";

export const usePaginatedPaymentActivity = (pageNumber: number) => {
  return useSelector((state) =>
    selectPaginatedPaymentActivity(state, pageNumber),
  );
};

export const usePaymentActivity = () => {
  return useSelector(selectPaymentActivity);
};

export const useFormattedPaginatedPaymentActivity = (pageNumber: number) => {
  return useSelector((state) =>
    selectFormattedPaginatedPaymentActivity(state, pageNumber),
  );
};

export const useFormattedPaymentActivityByKey = (key: string) => {
  const selectFormattedByKey = useMemo(
    createSelectFormattedPaymentActivityByKey,
    [],
  );
  return useSelector((state: RootState) => selectFormattedByKey(state, key));
};

export const usePaymentActivityTotal = () => {
  return useSelector(selectTotal);
};

export const usePaymentActivityMap = () => {
  return useSelector(selectPageMap);
};

export const useSelectedPaymentActivity = () => {
  return useSelector(selectSelectedPaymentActivity);
};

export const useResetPaymentActivity = () => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    dispatch(actions.resetState());
  }, [dispatch]);
};

export const usePaymentActivityFilters = () => {
  return useSelector(selectFilters);
};

export const usePaymentActivityById = () => {
  return useSelector(selectById);
};
